// Centralised data-testid registry for CCDR site.
export const NAV = {
  brand: "nav-brand",
  toggle: "nav-mobile-toggle",
  link: (slug) => `nav-link-${slug}`,
  group: (slug) => `nav-group-${slug}`,
  newsletterButton: "nav-newsletter-button",
};

export const HOME = {
  hero: "home-hero",
  heroCtaPrimary: "home-hero-cta-primary",
  heroCtaSecondary: "home-hero-cta-secondary",
  trustBand: "home-trust-band",
  focusCard: (slug) => `home-focus-card-${slug}`,
  insightCard: (slug) => `home-insight-card-${slug}`,
};

export const FOCUS = {
  card: (slug) => `focus-area-card-${slug}`,
  accordion: (slug) => `focus-area-accordion-${slug}`,
};

export const FRAMEWORKS = {
  filter: (slug) => `framework-filter-${slug}`,
  row: (slug) => `framework-row-${slug}`,
};

export const SDG = {
  tile: (n) => `sdg-tile-${n}`,
  detail: "sdg-detail-panel",
};

export const INSIGHTS = {
  card: (slug) => `insight-card-${slug}`,
  filter: (slug) => `insight-filter-${slug}`,
};

export const CONTACT = {
  form: "contact-form",
  fieldName: "contact-field-name",
  fieldEmail: "contact-field-email",
  fieldOrg: "contact-field-organisation",
  fieldPathway: "contact-field-pathway",
  fieldSubject: "contact-field-subject",
  fieldMessage: "contact-field-message",
  fieldConsent: "contact-field-consent",
  fieldFile: "contact-field-file",
  submit: "contact-submit",
  success: "contact-success",
  error: "contact-error",
};

export const NEWSLETTER = {
  form: "newsletter-form",
  fieldEmail: "newsletter-field-email",
  submit: "newsletter-submit",
  success: "newsletter-success",
  error: "newsletter-error",
};

export const MATURITY = {
  start: "maturity-start",
  question: (i) => `maturity-question-${i}`,
  option: (i, v) => `maturity-q${i}-option-${v}`,
  submit: "maturity-submit",
  result: "maturity-result",
};

export const FOOTER = {
  root: "footer-root",
  newsletterForm: "footer-newsletter-form",
  newsletterEmail: "footer-newsletter-email",
  newsletterSubmit: "footer-newsletter-submit",
};
